import createIcon from '../../createIcon';

/**
 * @component @name LocalShipping
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgOEgxN1Y0SDNDMS45IDQgMSA0LjkgMSA2VjE3SDNDMyAxOC42NiA0LjM0IDIwIDYgMjBDNy42NiAyMCA5IDE4LjY2IDkgMTdIMTVDMTUgMTguNjYgMTYuMzQgMjAgMTggMjBDMTkuNjYgMjAgMjEgMTguNjYgMjEgMTdIMjNWMTJMMjAgOFpNNiAxOC41QzUuMTcgMTguNSA0LjUgMTcuODMgNC41IDE3QzQuNSAxNi4xNyA1LjE3IDE1LjUgNiAxNS41QzYuODMgMTUuNSA3LjUgMTYuMTcgNy41IDE3QzcuNSAxNy44MyA2LjgzIDE4LjUgNiAxOC41Wk0xOS41IDkuNUwyMS40NiAxMkgxN1Y5LjVIMTkuNVpNMTggMTguNUMxNy4xNyAxOC41IDE2LjUgMTcuODMgMTYuNSAxN0MxNi41IDE2LjE3IDE3LjE3IDE1LjUgMTggMTUuNUMxOC44MyAxNS41IDE5LjUgMTYuMTcgMTkuNSAxN0MxOS41IDE3LjgzIDE4LjgzIDE4LjUgMTggMTguNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalShipping = createIcon('LocalShipping', [
  [
    'path',
    {
      d: 'M20 8H17V4H3C1.9 4 1 4.9 1 6V17H3C3 18.66 4.34 20 6 20C7.66 20 9 18.66 9 17H15C15 18.66 16.34 20 18 20C19.66 20 21 18.66 21 17H23V12L20 8ZM6 18.5C5.17 18.5 4.5 17.83 4.5 17C4.5 16.17 5.17 15.5 6 15.5C6.83 15.5 7.5 16.17 7.5 17C7.5 17.83 6.83 18.5 6 18.5ZM19.5 9.5L21.46 12H17V9.5H19.5ZM18 18.5C17.17 18.5 16.5 17.83 16.5 17C16.5 16.17 17.17 15.5 18 15.5C18.83 15.5 19.5 16.17 19.5 17C19.5 17.83 18.83 18.5 18 18.5Z',
      key: '18pllz',
    },
  ],
]);

export default LocalShipping;
